import { Button, Dialog, DialogBody, DialogContent, DialogFooter, DialogTrigger } from '@civilgrid/ui/components';
import type React from 'react';

interface Props {
  trigger: React.ReactNode;
  title: Exclude<React.ReactNode, null | undefined | boolean>;
  onConfirm?: () => Promise<void> | void;
  children?: React.ReactNode;
  /** Lands on the dialog; the X and Delete button get `-close` and `-confirm` suffixes. */
  'data-testid'?: string;
}

export default function DeleteDialog({
  onConfirm,
  title,
  trigger,
  children,
  'data-testid': testId = 'civilsearch-delete-dialog',
}: Props) {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        title={title}
        className="z-[110] w-auto min-w-min max-w-[75vw]"
        overlayClassName="z-[100]"
        data-testid={testId}
      >
        <DialogBody className="min-w-[16rem] text-sm">{children ? children : <div>Confirm deletion.</div>}</DialogBody>
        <DialogFooter>
          <Button onClick={onConfirm} data-testid={`${testId}-confirm`}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
